import * as classNames from 'classnames';
import * as React from 'react';
import * as CSSModules from 'react-css-modules';

import { eventTealiumLink } from 'state/tealium';
import { smellyStoreSingleton } from 'utils/store';
import Props from './social-props';

const styles = require('./social.less');

@CSSModules(styles, { allowMultiple: true })
class Snapchat extends React.Component<Props> {
    render() {
        const {
            props: { black },
        } = this;
        return (
            <a
                target="_blank"
                href={__('social.twitter_href')}
                rel="noopener"
                styleName={classNames('social', { black })}
                onClick={this.tealiumEventSnapchat}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="33"
                    height="33"
                    viewBox="0 0 33 33"
                >
                    <title>Snapchat Visible</title>
                    <defs>
                        <path id="a" d="M0 0h33v33H0z" />
                    </defs>
                    <g fill="none" fillRule="evenodd">
                        <mask id="b" fill="#fff">
                            {/*<use xlink:href="#a"/>*/}
                        </mask>
                        <path
                            fill="#1800FF"
                            // tslint:disable-next-line:max-line-length
                            d="M16.765 1h-.001l-.134.001-.415.004c-3.205 0-7.344 1.567-9.33 5.966-.557 1.236-.699 2.743-.693 4.223-1.671.292-3.054 1.533-3.357 3.114-.132.683-.309 2.898 2.448 4.285-.555.66-1.372 1.352-2.436 1.526-1.716.28-2.937 1.784-2.842 3.499.024.41.118.809.28 1.187.679 1.569 2.241 2.332 3.959 2.767.537 1.31 1.779 2.14 3.257 2.14.45 0 .845-.077 1.161-.139.295-.056.575-.11.913-.11.175 0 .359.014.545.044.159.064.542.33.823.528 1.12.783 2.812 1.965 5.388 1.965l.157-.002a10 10 0 0 0 .182.002c2.576 0 4.267-1.182 5.386-1.965.283-.197.665-.464.824-.528.187-.03.37-.045.545-.045.325 0 .592.04.916.101.44.086.82.127 1.158.127h.001c1.463 0 2.715-.837 3.252-2.119 1.718-.434 3.282-1.193 3.957-2.75.165-.38.262-.785.285-1.2.099-1.717-1.123-3.222-2.838-3.502-1.064-.174-1.881-.865-2.438-1.527 2.207-1.112 2.529-2.754 2.511-3.683-.03-1.555-1.07-2.925-2.656-3.506a4.236 4.236 0 0 0-.763-.216c.005-1.477-.137-2.983-.695-4.219C24.13 2.568 19.983 1 16.765 1zm-.003 3c1.116 0 4.899.307 6.68 4.242.6 1.324.457 3.574.34 5.38l-.003.077a50.07 50.07 0 0 0-.036.569c.083.045.23.101.453.11.338-.014.73-.123 1.164-.324.186-.085.383-.103.517-.103.195 0 .396.037.563.106l.002.001c.5.176.814.53.822.928.01.507-.45.944-1.364 1.3-.112.043-.249.086-.393.132-.516.16-1.297.404-1.508.896-.11.255-.067.583.129.974l.013.027c.068.157 1.72 3.868 5.39 4.464a.553.553 0 0 1 .468.575.68.68 0 0 1-.06.248c-.275.632-1.437 1.096-3.552 1.42-.07.093-.144.424-.189.627-.044.204-.09.404-.154.618-.088.296-.31.46-.624.46h-.032c-.149 0-.355-.025-.609-.075a7.352 7.352 0 0 0-1.44-.15 6.46 6.46 0 0 0-1.03.086c-.683.112-1.262.515-1.936.983-.961.67-2.05 1.429-3.705 1.429-.075 0-.144-.003-.199-.005-.044.003-.09.005-.136.005-1.655 0-2.744-.759-3.706-1.429-.672-.467-1.252-.87-1.934-.983a6.463 6.463 0 0 0-1.032-.086c-.604 0-1.086.093-1.44.161-.234.045-.437.085-.608.085-.426 0-.592-.257-.656-.47a8.462 8.462 0 0 1-.154-.624c-.046-.203-.12-.536-.19-.63-2.115-.323-3.276-.788-3.552-1.422a.735.735 0 0 1-.06-.248.555.555 0 0 1 .469-.575c3.669-.595 5.322-4.306 5.39-4.464l.012-.027c.197-.391.24-.719.13-.974-.211-.492-.992-.736-1.508-.897-.145-.045-.28-.087-.393-.132-1.25-.485-1.425-1.045-1.35-1.428.103-.532.761-.89 1.312-.89.16 0 .304.03.429.087.47.218.887.327 1.241.327.264 0 .433-.063.525-.112l-.04-.648c-.116-1.806-.259-4.054.34-5.377 1.781-3.933 5.556-4.239 6.67-4.239l.466-.004.067-.001z"
                            mask="url(#b)"
                        />
                    </g>
                </svg>
            </a>
        );
    }
    private readonly tealiumEventSnapchat = () => {
        const { dispatch } = smellyStoreSingleton.store;
        const page = window.location.pathname.replace('/', '');
        dispatch(
            eventTealiumLink({
                flow_name: '',
                page_name: page,
                tealium_event: 'snapchat',
                link_location: 'footer',
                link_type: 'icon',
            }),
        );
    };
}

export { Snapchat };
